export var CSS = {
  props: {
    inline: 'props-inline',
    value: 'props-value',
    title: 'props-title'
  }
};